import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlask, faCheckCircle, faFileAlt } from '@fortawesome/free-solid-svg-icons';

const LabTestsPage: React.FC = () => {
  const labTestImages = [
    {
      location: 'Skardu',
      images: [
        'https://i.postimg.cc/wvxSMfSt/AR-25-HE-195255-01-5-pdf-1.png',
        'https://i.postimg.cc/BQPRj1wC/AR-25-HE-195255-01-5-pdf-2.png'
      ]
    },
    {
      location: 'Gilgit',
      images: [
        'https://i.postimg.cc/YqgGbbsL/AR-25-HE-204576-01-pdf-1.png',
        'https://i.postimg.cc/wjQtd3H6/AR-25-HE-204576-01-pdf-2.png'
      ]
    }
  ];

  return (
    <div className="pt-16 min-h-screen bg-gray-50">
      <div className="bg-white text-[#2b603e] py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">Lab Test Transparency</h1>
          <p className="text-xl max-w-3xl mx-auto text-[#2b603e]/80">
            Comprehensive laboratory testing of our pure Himalayan Shilajit
          </p>
        </div>
      </div>

      <section className="py-16 container mx-auto px-4">
        {labTestImages.map((testSet, index) => (
          <div key={index} className="mb-16">
            <h2 className="text-3xl font-bold text-[#2b603e] mb-8 text-center">
              {testSet.location} Shilajit Lab Test
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              {testSet.images.map((imageUrl, imgIndex) => (
                <div 
                  key={imgIndex} 
                  className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300"
                >
                  <img 
                    src={imageUrl} 
                    alt={`${testSet.location} Shilajit Lab Test ${imgIndex + 1}`} 
                    className="w-full object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default LabTestsPage; 